module.exports = __webpack_public_path__ + "static/img/90.55b7df3a.png";